import { ESITO, STATO } from "@/pages/cauzioni/labels";

export function EsitoBadge({ esito, className = "" }) {
  if (!esito) return <span className={`inline-flex items-center rounded-sm border px-2 py-0.5 text-xs bg-slate-100 text-slate-500 border-slate-200 ${className}`}>Da valutare</span>;
  const e = ESITO[esito] || ESITO.non_proponibile;
  return <span data-testid="esito-badge" className={`inline-flex items-center rounded-sm border px-2.5 py-0.5 text-xs font-medium ${e.cls} ${className}`}>{e.label}</span>;
}

export function StatoBadge({ stato }) {
  const s = STATO[stato] || STATO.bozza;
  return <span className={`inline-flex items-center rounded-sm border px-2 py-0.5 text-xs ${s.cls}`}>{s.label}</span>;
}
